<template>
  <div class="layout-wrapper">
    <div class="layout">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  $py: 17px;
  $px: 40px;
  $maxw: 1720px;

  $medium-maxw: 1156px;

  $mobile-px: 15px;

  .layout {
    &-wrapper {
      padding: $py $px;
    }

    position: relative;
    max-width: $maxw;
    margin: 0 auto;
    min-height: calc(100vh - #{$py + $py});

    @include respond-to(medium) {
      max-width: $medium-maxw;
    }
    @media screen and (max-width: $tabletRotate) and (min-width: $mobileRotate){
      max-width: 535px;
    }
    @include respond-to(mobileRotate) {
      &-wrapper {
        padding: $py $mobile-px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue